export const SET = "receivingRecord/SET";
export const SET_INVENTORY = "receivingRecord/SET_INVENTORY";
export const SET_MODAL = "receivingRecord/SET_MODAL";
export const SET_DISCREPANCIES = "receivingRecord/SET_DISCREPANCIES";
export const REMOVE_DISCREPANCIES = "receivingRecord/REMOVE_DISCREPANCIES";



// WEBPACK FOOTER //
// ./app/modules/Receiving/actionTypes.js